import { cn } from 'components/common/utils/tailwindUtils'
import tw from 'twin.macro'

export const TwCardContainer = tw.div`rounded-3xl p-2 overflow-hidden relative`
